import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  FormFeedback,
} from "reactstrap"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import LoadingComponent from "components/Loading/LoadingComponent"
import { useFormik } from "formik"
import * as Yup from "yup"
import Select from "react-select"
import { MetaTags } from "react-meta-tags"
import RtwProductAction from "store/rtw-product-resource/actions"
import CompanyAction from "store/company-resource/actions"
import SeasonAction from "store/season-resource/actions"

export default function DetailRtwProduct() {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()
  const store = useSelector(state => state)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      number: "",
      supplierId: "",
      supplierName: "",
      year: "",
      seasonId: "",
      seasonName: "",
      name: "",
      unitPrice: "",
      status: true,
      statusName: "販売中",
    },
    validationSchema: Yup.object({
      supplierId: Yup.string().required("お取引先 必須項目です。"),
      year: Yup.string().required("年度 必須項目です。"),
      seasonId: Yup.string().required("シーズン 必須項目です。"),
      name: Yup.string().required("商品名 必須項目です。"),
      unitPrice: Yup.number().required("単価 必須項目です。"),
      status: Yup.boolean().required("廃盤 必須項目です。"),
    }),
    onSubmit: values => {
      if (params.id === "add") {
        dispatch(RtwProductAction.postData(values, callbackPost))
      } else {
        dispatch(
          RtwProductAction.putData({ ...values, id: params.id }, callbackPut)
        )
      }
    },
  })

  const callbackPost = () => {
    history.push("/master/rtw-product")
    validation.resetForm()
  }

  const callbackPut = () => {
    history.push("/master/rtw-product")
    validation.resetForm()
  }

  const callbackGetDetail = data => {
    validation.setValues(data)
    const status = store.rtwProduct.status.find(i => i.value == data.status)
    validation.setFieldValue("statusName", status.label)
  }

  React.useEffect(() => {
    if (params.id !== "add") {
      dispatch(RtwProductAction.getDetail({ id: params.id }, callbackGetDetail))
    }
  }, [params.id])

  React.useEffect(() => {
    dispatch(CompanyAction.getList())
    dispatch(SeasonAction.getList())
  }, [])

  const optionYear = [
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "28", value: "28" },
  ]

  return (
    <>
      <MetaTags>
        <title>個人顧客管理 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="RTW商品マスター" breadcrumbList={[]} />
          <Card>
            <CardBody>
              {store.rtwProduct.detail.loading ? (
                <LoadingComponent />
              ) : (
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row>
                    <Col md={8}>
                      <p className="fw-bold">
                        {params.id != "add"
                          ? "RTW商品マスター詳細"
                          : "新規RTW商品マスター追加"}
                      </p>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      <Button
                        color="primary"
                        type="submit"
                        className="button me-2"
                      >
                        保存
                      </Button>
                      <br />
                      <Button
                        color="warning"
                        type="button"
                        className="button"
                        onClick={() => history.push("/master/rtw-product")}
                      >
                        キャンセル
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col sm="8">
                      <FormGroup row>
                        <Label sm="2">商品コード</Label>
                        <Col sm="6">
                          <Input
                            name="number"
                            className="form-control"
                            type="text"
                            value={validation.values.number || ""}
                            disabled
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm="2">お取引先</Label>
                        <Col sm="6">
                          <Select
                            isLoading={store.company.list.loading}
                            options={store.company.list.data.map(i => ({
                              value: i.id,
                              label: i.name,
                            }))}
                            defaultValue={{
                              value: validation.values.supplierId,
                              label: validation.values.supplierName,
                            }}
                            value={{
                              value: validation.values.supplierId,
                              label: validation.values.supplierName,
                            }}
                            onChange={e => {
                              validation.setFieldValue("supplierId", e.value)
                              validation.setFieldValue("supplierName", e.label)
                            }}
                            isDisabled={params.id != "add"}
                          />
                          <Input
                            name="supplierId"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.supplierId || ""}
                            invalid={
                              validation.touched.supplierId &&
                              validation.errors.supplierId
                                ? true
                                : false
                            }
                          />
                          {validation.touched.supplierId &&
                          validation.errors.supplierId ? (
                            <FormFeedback type="invalid">
                              {validation.errors.supplierId}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm="2">年度</Label>
                        <Col sm="6">
                          <Select
                            options={optionYear}
                            defaultValue={{
                              value: validation.values.year,
                              label: validation.values.year,
                            }}
                            value={{
                              value: validation.values.year,
                              label: validation.values.year,
                            }}
                            onChange={e => {
                              validation.setFieldValue("year", e.value)
                              validation.setFieldValue("year", e.label)
                            }}
                            isDisabled={params.id != "add"}
                          />
                          <Input
                            name="year"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.year || ""}
                            invalid={
                              validation.touched.year && validation.errors.year
                                ? true
                                : false
                            }
                            disabled={params.id != "add"}
                          />
                          {validation.touched.year && validation.errors.year ? (
                            <FormFeedback type="invalid">
                              {validation.errors.year}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">シーズン</Label>
                        <Col sm="6">
                          <Select
                            isLoading={store.seasonPage.list.loading}
                            options={store.seasonPage.list.data.map(i => ({
                              value: i.id,
                              label: i.name,
                            }))}
                            defaultValue={{
                              value: validation.values.seasonId,
                              label: validation.values.seasonName,
                            }}
                            value={{
                              value: validation.values.seasonId,
                              label: validation.values.seasonName,
                            }}
                            onChange={e => {
                              validation.setFieldValue("seasonId", e.value)
                              validation.setFieldValue("seasonName", e.label)
                            }}
                            isDisabled={params.id != "add"}
                          />
                          <Input
                            name="seasonId"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.seasonId || ""}
                            invalid={
                              validation.touched.seasonId &&
                              validation.errors.seasonId
                                ? true
                                : false
                            }
                          />
                          {validation.touched.seasonId &&
                          validation.errors.seasonId ? (
                            <FormFeedback type="invalid">
                              {validation.errors.seasonId}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm="2">商品名</Label>
                        <Col sm="6">
                          <Input
                            name="name"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm="2">単価</Label>
                        <Col sm="6">
                          <Input
                            name="unitPrice"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.unitPrice || ""}
                            invalid={
                              validation.touched.unitPrice &&
                              validation.errors.unitPrice
                                ? true
                                : false
                            }
                          />
                          {validation.touched.unitPrice &&
                          validation.errors.unitPrice ? (
                            <FormFeedback type="invalid">
                              {validation.errors.unitPrice}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm="2">廃盤</Label>
                        <Col sm="6">
                          <Select
                            options={store.rtwProduct.status}
                            defaultValue={{
                              value: validation.values.status,
                              label: validation.values.statusName,
                            }}
                            value={{
                              value: validation.values.status,
                              label: validation.values.statusName,
                            }}
                            onChange={e => {
                              validation.setFieldValue("status", e.value)
                              validation.setFieldValue("statusName", e.label)
                            }}
                          />
                          <Input
                            name="status"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.status || ""}
                            invalid={
                              validation.touched.status &&
                              validation.errors.status
                                ? true
                                : false
                            }
                          />
                          {validation.touched.status &&
                          validation.errors.status ? (
                            <FormFeedback type="invalid">
                              {validation.errors.status}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}
